import { FC, useEffect, useState } from "react";
import { UseSalarySimContext } from "../Context/SalarySimContext";

import '../css/normalize.css';
import '../css/webflow.css';
import '../css/salarysimwebflow.css';
import '../css/salarysimwebflow_custom.css';
import '../css/salarysim.css';
import StepButtonComponent from "./StepButtonComponent";
import { UseConfigContext } from "../Context/ConfigContext";

interface StepperProps {
    currentStep: number
    requestStepChange(wantedStep: number, askForValidation : boolean) : void // for navigation in the stepper
}

const Stepper: FC<StepperProps> = (props) => {

    const { isSimpleSimulationMode } = UseSalarySimContext();
    const {checkInternalVersion} = UseConfigContext();

    const onStepClick = (wantedStep: number) => {
        props.requestStepChange(wantedStep, false);
    }

    const getCSSClass = () => {
        if(isSimpleSimulationMode == false && props.currentStep == 1)
        {
            if(checkInternalVersion() == true)
            {
                return "stepper marge no-print";
            }
            else
            {
                return "stepper margeexternal no-print";
            }
        }
        else if((isSimpleSimulationMode == false && props.currentStep == 4) || (isSimpleSimulationMode && props.currentStep == 3))
        {
            return "stepper result no-print";
        }
        else
        {
            return "stepper no-print";
        }
    }

    const HandleSimulationModeDisplay = () => {

        if (isSimpleSimulationMode) {
            return (
                <>
                <nav id="stepper-nav" role="navigation" className={getCSSClass()}>
                    <StepButtonComponent buttonStep={1} buttonTitle ={"DONNEES_SIGNALETIQUES"} currentStep={props.currentStep} requestStepChange={onStepClick} />
                    <StepButtonComponent buttonStep={2} buttonTitle ={"TYPE_CONTRAT"} currentStep={props.currentStep} requestStepChange={onStepClick} />
                    <StepButtonComponent buttonStep={3} buttonTitle ={"CALC_RESULT"} currentStep={props.currentStep} requestStepChange={onStepClick} />
                    <div id="line" className="lines">
                        <div className="line"></div>
                        <div className="line _32 grey"></div>
                        <div className="line _32 grey"></div>
                        <div className="line"></div>
                    </div>
                </nav>
            </>
            );
        }
        else {
            return (
                <>
                    <nav id="stepper-nav" role="navigation" className={getCSSClass()}>

                    <StepButtonComponent buttonStep={1} buttonTitle ={"DONNEES_SIGNALETIQUES"} currentStep={props.currentStep} requestStepChange={onStepClick} />
                    <StepButtonComponent buttonStep={2} buttonTitle ={"TYPE_CONTRAT"} currentStep={props.currentStep} requestStepChange={onStepClick} />
                    <StepButtonComponent buttonStep={3} buttonTitle ={"COMPONENTS"} currentStep={props.currentStep} requestStepChange={onStepClick} />
                    <StepButtonComponent buttonStep={4} buttonTitle ={"CALC_RESULT"} currentStep={props.currentStep} requestStepChange={onStepClick} />

                        <div id="lines" className="lines">
                            <div className="line-four-steps"></div>
                            <div className="line _32 grey"></div>
                            <div className="line _32 grey"></div>
                            <div className="line _32 grey"></div>
                            <div className="line-four-steps"></div>
                        </div>
                    </nav>
                </>
            )
        }

    }

    return (
        <>
            {HandleSimulationModeDisplay()}
        </>
    );

}

export default Stepper;